import { useContext, useEffect, useState } from "react"

import { useSelector, useDispatch } from "react-redux"
import { Dispatch } from "redux"
import * as actions from './../../../shared/StoreContainer/actionCreators';

import { UserContext, Config } from "../../../App"
import { sendMetricContacts } from "../../../shared/MetricApi"
import User from '../../../shared/icons/user.svg'
import Exit from '../../../shared/icons/exitCross.svg'
import classNames from "./styles.module.scss"

export const GetContact = (props: { style?: any }) => {
  const dispatch: Dispatch<any> = useDispatch();
  //@ts-ignore
  const contactOpenedContainer = useSelector((state) => (state?.containerContactOpened));

  //@ts-ignore
  const idInContainer = useSelector((state) => (state?.containerUser?.user?.id));

  const [opened, setOpened] = useState<boolean | string>(false)
  const [input, setInput] = useState<string>('')
  const [whereFrom, setWhereFrom] = useState<string>('')
  const [name, setName] = useState<string>('')
  const user = useContext(UserContext).user
  const id = useContext(UserContext).id

  useEffect(() => {
    setOpened(contactOpenedContainer.opened)
    setName(typeof (contactOpenedContainer.opened.valueOf()) === "string" ? contactOpenedContainer.opened.valueOf() : '');
  }, [contactOpenedContainer])

  useEffect(() => {
    if (opened) window.addEventListener("click", close)
    else window.removeEventListener("click", close)
    function close(e: MouseEvent) {
      //@ts-ignore
      if (!e.target?.classList.contains('GetContact')) {
        actions.complexActionForContact(dispatch, false, undefined);
        window.removeEventListener("click", close)
      }
    }
    // eslint-disable-next-line
  }, [opened])


  function send() {
    console.log(idInContainer, input)
    //@ts-ignore
    idInContainer && sendMetricContacts(idInContainer, input, whereFrom + (name === Config.texts.report.noRegionStub ? '' : ', выбрал территорию ' + name), Config.texts.appName)

    //@ts-ignore
    document.getElementById('contP') && (document.getElementById('contP').style.display = 'none')
    //@ts-ignore
    document.getElementById('contDiv') && (document.getElementById('contDiv').style.display = 'none')
    //@ts-ignore
    document.getElementById('thanks') && (document.getElementById('thanks').style.display = 'flex')
    setTimeout(() => {
      //@ts-ignore
      document.getElementById('thanks') && (document.getElementById('thanks').style.display = 'none')
      actions.complexActionForContact(dispatch, false, undefined);
      dispatch(actions.setDrawEnabled(false));
    }, 2000);
  }

  console.log(name);

  return <>{
    opened && <div className={classNames.contact + ' GetContact'} style={props.style ? { ...props.style } : {}}>
      <img id="exitPopup" className={classNames.cross} alt="close icon" src={Exit} onClick={() => { actions.complexActionForContact(dispatch, false, undefined) }} />
      {/* @ts-ignore */}
      <div id="thanks" className={classNames.thanks + ' GetContact'}>{Config.texts.report.thanks}</div>
      {/* @ts-ignore */}
      <p id='contP' className={classNames.contactTitle + ' GetContact'}>{Config.texts.report.header} <br />{name ? name : ''}</p>
      <div id='contDiv' className={classNames.formContainer + ' GetContact'}>
        {/* @ts-ignore */}
        <p className="GetContact" dangerouslySetInnerHTML={{ __html: Config.texts.report.hint }} />

        <div className={classNames.inputContainer + ' GetContact'}>
          {/* @ts-ignore */}
          <input className={classNames.input + ' GetContact'} onChange={(e) => setInput(e.target.value)} placeholder={Config.texts.report.placeholder} />
          <img src={User} className={classNames.user + ' GetContact'} alt="user icon" />
        </div>
        <div className={classNames.inputContainer + ' GetContact'}>
          {/* @ts-ignore */}
          <input className={classNames.input + ' GetContact'} onChange={(e) => setWhereFrom(e.target.value)} placeholder={Config.texts.report.whereFromPlaceholder} />
        </div>

        {/* @ts-ignore */}
        <div className={classNames.send + ' ' + ((input.length < 1) ? classNames.nonactive : '') + ' GetContact'} onClick={() => input.length > 0 && send()}> <p className="GetContact">{Config.texts.report.request}</p> </div>
      </div>
    </div>}
  </>

}